/*
 * General-purpose popup
 */

import { animate as motionAnimate2, timeline as motionTimeline2 } from "vendor";
import { DialogElement } from "theme";

var Popup = class extends DialogElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" }).appendChild(document.getElementById(this.template).content.cloneNode(true));
  }
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.querySelector('[part="overlay"]')?.addEventListener("click", this.hide.bind(this), { signal: this._abortController.signal });
    this.controls.forEach((control) => control.setAttribute("aria-haspopup", "dialog"));
    
    // Prevent infinite loop: only move it if it's not already next to main
    const main = document.querySelector('main');
    if (main && this.previousElementSibling !== main) {
      main.insertAdjacentElement('afterend', this);
    }
  }
  get template() {
    return this.getAttribute("template") || "popup-default-template";
  }
  get shouldLock() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get shouldAppendToBody() {
    return window.matchMedia("screen and (max-width: 999px)").matches;
  }
  get anchor() {
    return {
      vertical: this.getAttribute("anchor-vertical") || "start",
      horizontal: this.getAttribute("anchor-horizontal") || "end"
    };
  }
  _showTransition(animate19 = true) {
    let animationControls, content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
    this.style.display = "block";
    animationControls = motionTimeline2([
      [this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.15 }],
      [content, { clipPath: ["inset(50% 0 50% 0 round 8px)", "inset(0 0 0 0 round 8px"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
      [content.children, { opacity: [0, 1] }, { duration: 0.15 }],
      [closeButton, { opacity: [0, 1] }, { at: "<", duration: 0.15 }]
    ]);
    animate19 ? animationControls.play() : animationControls.finish();
    return animationControls.finished;
  }
  _hideTransition() {
    let animationControls;
    let content = this.shadowRoot.querySelector('[part="content"]'), closeButton = this.shadowRoot.querySelector('[part="outside-close-button"]');
    animationControls = motionTimeline2([
      [closeButton, { opacity: [null, 0] }, { duration: 0.15 }],
      [content.children, { opacity: [null, 0] }, { at: "<", duration: 0.15 }],
      [content, { clipPath: [null, "inset(50% 0 50% 0 round 8px)"] }, { duration: 0.4, easing: [0.86, 0, 0.07, 1] }],
      [this, { opacity: [null, 0], visibility: ["visible", "hidden"] }, { duration: 0.15 }]
    ]);
    return animationControls.finished.then(() => this.style.display = "none");
  }
};
if (!window.customElements.get("x-popup")) {
  window.customElements.define("x-popup", Popup);
}
